import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { AuthAPI } from '../../../api';
import ProviderLoginForm from './ProviderLoginForm';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles({
  loginContainer: {
    maxWidth: 400,
  },
});

const ProviderLoginContainer = ({initialUsername}) => {
  const history = useHistory();
  const location = useLocation();
  const compactLayout = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const classes = useStyles();

  const onLogin = (profile) => {
    let redirectTo = '/providers/profile';
    if (location.state && location.state.redirectTo) {
      // if there has been an explicit redirect passed, use that.
      redirectTo = location.state.redirectTo;
    } else {
      // if not on mobile, go to first provider profile we have Edit Provider rights for (if any)
      if (!compactLayout) {
        const adminRoles = profile.roles.filter(role => role.permissions.includes('Edit Provider'));
        if (adminRoles.length) {
          redirectTo = `/provider/${adminRoles[0].provider_uuid}/admin/profile`;
        }
      }
    }
    history.push(redirectTo);
  };

  return (
    <div className={classes.loginContainer}>
      <ProviderLoginForm
        initialUsername={initialUsername}
        onComplete={onLogin}
        loginApi={AuthAPI.providerLogin}
        recoveryLink="/providers/password/recover"
        signUpLink="/providers/signup"
        title="Already Have a Provider Account?"
        titleVariant="h3"
      />
    </div>
  );
};

ProviderLoginContainer.propTypes = {
  initialUsername: PropTypes.string,
};

export default ProviderLoginContainer;
